import AnimatedLottieView from "lottie-react";
import { useTranslation } from "react-i18next";
import { StyleSheet, View } from "react-native";
import { LottieAnimation } from "../../../config/lottie";
import { StyleHelpers } from "../../../constants/style-helpers";
import { verticalSize, height } from "../../../functions/responsive";
import { THEME_COLORS } from "../../../theme/constants/themeColors";
import CText from "../CText";
import { APP_VARIANT } from "../../../config/setting";
import { THEME_ASSETS } from "../../../theme/constants/themeAssets";

// type Props = {}
export function FullScreenRipple(props: {showMessage?: boolean}) {
  const { t } = useTranslation();
  return (
    <View style={styles.root}>
      <AnimatedLottieView animationData={THEME_ASSETS.SearchingRipple} autoPlay style={styles.animation} />
      <View style={styles.subView}></View>
      {
        props.showMessage &&
        <View style={styles.absoluteCont}>
          <CText style={{ fontWeight: "600" }} value={t("searchingNearest")} size={26} bold />
          <CText style={{ fontWeight: "600" }} value={t("chargersForYouLC")} size={26} bold />
        </View>
      }
    </View>
  );
}

const styles = StyleSheet.create({
  root: {
    backgroundColor: THEME_COLORS.bgColor
    // alignItems: "center",
    // height: height(100),
    // width: horizontalSize(100)
  },
  absoluteCont: {
    position: "absolute",
    alignItems: "center",
    justifyContent: "center",
    alignSelf: "center",
    top: verticalSize(60)
  },
  subView: {
    position: "absolute",
    height: "100%",
    width: "100%",
    left: 0,
    top: 0,
    ...StyleHelpers.totalCenter
  },
  animation: {
    // height: height(100),
  }
});
